import React, { useState, ReactNode } from 'react'
import { Menu, MenuItem, IconButton } from '@mui/material'
import { EllipsisVertical } from 'lucide-react'

interface MenuItemType {
  id: string
  label: string
  icon?: ReactNode
  onClick: (e: React.MouseEvent) => void
  hide?: boolean
}

interface DropdownMenuProps {
  menuItems: MenuItemType[]
}

const DropdownMenu: React.FC<DropdownMenuProps> = ({ menuItems }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleKeyDown = (event: React.KeyboardEvent) => {
    event.stopPropagation()
    if (event.key === 'Escape') {
      handleClose()
    }
  }

  return (
    <button
      type='button'
      onClick={(event) => event.stopPropagation()}
      onKeyDown={handleKeyDown}
      style={{ all: 'unset' }}
    >
      <IconButton
        aria-label='more'
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        onClick={(event) => handleClick(event)}
      >
        <EllipsisVertical />
      </IconButton>
      <Menu
        id='basic-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {menuItems
          .filter((item) => !item.hide)
          .map((item) => (
            <MenuItem
              key={item.id}
              onClick={(event) => {
                item.onClick(event)
                handleClose()
              }}
            >
              {item.icon && (
                <span
                  style={{
                    marginRight: '8px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {item.icon}
                </span>
              )}
              {item.label}
            </MenuItem>
          ))}
      </Menu>
    </button>
  )
}

export default DropdownMenu
